import { Trans } from '@lingui/macro';
import React from 'react';
import AuthLayout from '../layout';
import { getRedirectUri } from '../../util/ChangeLanguage';


export default function ActiveAccount() {
  const redirectToHome = () => {
    window.location.href = getRedirectUri();
  };
  return (
    <>
        <AuthLayout>
          <div className='flex flex-col items-center'>
            <div className='text-black text-center text-[20px] font-bold mb-[30px]'>
              <Trans>Vui lòng liên hệ admin để được thêm vào tổ chức</Trans>
            </div>
            <button
              onClick={() => redirectToHome()}
              className="rounded w-fit py-2 px-5 bg-luat_HN_primary hover:bg-luat_HN_primary_hover text-white transition duration-300"
            >
              <Trans>Quay lại trang chủ</Trans>
            </button>
          </div>
        </AuthLayout>
    </>
  );
}
